'use client';

import { createContext } from 'react';

import type { Entity } from '@/api/types/entityTypes';

export interface EntityContextType {
  setEntity: <T extends Entity>(entity: T) => void;
  getEntity: <T extends Entity>(entity_type: string, entity_id: string) => T | undefined;
}

export const EntityContext = createContext<EntityContextType | undefined>(undefined);
